/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import {
  Accordion,
  Badge,
  Form, ListGroup,
} from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';
import { controlla } from '../../utils/verificaPermessi';
import { client } from '../../utils/matrix';
import { getItem, removeItem, setItem } from '../../utils/storage';
import compartiService from '../../services/compartiService';
import { Context } from '../../utils/Context';
import history from '../../utils/history';
import manualiUtente from '../../utils/manualiUtente.json';

const gestioneCVUrl = process.env.REACT_APP_GESTIONE_CV_URL;
const visualizzaCTC = process.env.REACT_APP_VISUALIZZA_CTC;
const urlContenutiPubblici = process.env.REACT_APP_URL_CONTENUTI_PUBBLICI;

function Sidebar() {
  const [context, setContext] = useContext(Context);
  const {
    amministrazione, idComparto, idIdentita, idAmministrazione,
  } = getItem('identita') ? JSON.parse(getItem('identita')) : '';
  const { sequ_k_comparto } = getItem('compartoSelected') ? JSON.parse(getItem('compartoSelected')) : '';
  const { pathname } = useLocation();

  const [notification, setNotification] = useState(0);
  const [comparti, setComparti] = useState([]);
  const [compartoSelected, setCompartoSelected] = useState({});

  // Function collegata al servizio per ottenere la lista dei comparti
  async function getComparti() {
    try {
      const response = await compartiService.getAllComparti();
      setComparti(response);
      setItem('comparti', JSON.stringify(response));
      if (idComparto) {
        setItem('compartoSelected', JSON.stringify(response.filter((el) => el.sequ_k_comparto === idComparto)[0]));
        setCompartoSelected(idComparto);
      } else {
        setItem('compartoSelected', JSON.stringify(response.filter((el) => el.sequ_k_comparto === (sequ_k_comparto || 1))[0]));
        setCompartoSelected(sequ_k_comparto || 1);
      }
    } catch (err) {
      setContext(() => ({
        ...context, open: true, testoErrore: err?.data?.message || 'Errore', statusCode: err?.status,
      }));
    }
  }

  // useEffect
  useEffect(() => {
    client?.on(
      'event',
      () => {
        // let unreadMessage = 0;
        let unreadRoom = 0;
        client.getRooms().forEach((el) => {
          if (el.name !== 'Notifiche' && el.notificationCounts.total) {
            // unreadMessage += el.notificationCounts.total;
            unreadRoom += 1;
          }
        });
        setNotification(unreadRoom);
      },
    );
    if (controlla('Z0')) getComparti();
  }, []);

  // function attivata sull'onChange della select dei comparti
  const onSelectComparto = (comparto) => {
    setItem('compartoSelected', JSON.stringify(comparto));
    setCompartoSelected(comparto);
    history.push(pathname);
  };

  const removeItemFromStorage = () => {
    removeItem('filtri');
    removeItem('page');
    removeItem('pageDirettori');
    removeItem('pagePersonale');
    removeItem('visualizzazioneAmministrazionePTFA');
    removeItem('lastVersion');
    removeItem('lastVersionId');
  };

  return (
    <nav className="border-end bg-white" id="sidebar-wrapper" role="navigation" aria-label="Menu laterale sinistro">
      <div
        className="sidebar-heading border-bottom ms-1 fw-bold d-flex align-items-center"
        style={{
          verticalAlign: 'middle',
          overflow: 'hidden',
          whiteSpace: 'normal',
          textOverflow: 'clip',
          wordWrap: 'break-word',
          overflowY: 'hidden',
          textAlign: 'center',
        }}
      >
        {amministrazione}
      </div>
      <ListGroup>
        {controlla('Z0') && (
          <ListGroup.Item>
            <Form.Label>
              <span className="fw-semibold">Comparto</span>
            </Form.Label>
            <Select
              id="comparto"
              name="comparto"
              options={comparti}
              onChange={(selectedOption) => onSelectComparto(selectedOption)}
              placeholder="Scegli comparto"
              isDisabled={idComparto}
              getOptionLabel={(option) => option.desc_comparto}
              getOptionValue={(option) => option.sequ_k_comparto}
              value={comparti?.filter(
                (el) => el.sequ_k_comparto === compartoSelected,
              )?.[0]}
            />
          </ListGroup.Item>
        )}
        <ListGroup.Item
          active={pathname === '/area-riservata' ? 'active' : ''}
          onClick={() => removeItemFromStorage()}
          style={{ padding: '14px 19.2px' }}
        >
          <Link className="text-primary" to="/area-riservata">
            <FontAwesomeIcon aria-hidden="true" icon="home" style={{ marginRight: '6px' }} size="lg" />
            <span className="fw-semibold">
              {' '}
              Home
            </span>
          </Link>
        </ListGroup.Item>
        {(controlla('Z1') && (controlla('X46') || controlla('X47') || controlla('X48'))) && (
          <ListGroup.Item
            active={pathname === '/area-riservata/amministrazione'}
            onClick={() => removeItemFromStorage()}
            style={{ padding: '14px 19.2px' }}
          >
            <Link className="text-primary" to="/area-riservata/amministrazione">
              <FontAwesomeIcon aria-hidden="true" icon="users" style={{ marginRight: '6px' }} size="lg" />
              <span className="fw-semibold">
                Amministrazione
              </span>
            </Link>
          </ListGroup.Item>
        )}
        {controlla('Z2') && (
          <ListGroup.Item
            active={pathname === '/area-riservata/richiesta-identita'}
            style={{ padding: '14px 19.2px' }}
          >
            <Link className="text-primary" to="/area-riservata/richiesta-identita">
              <FontAwesomeIcon aria-hidden="true" icon="id-badge" style={{ marginRight: '6px' }} size="lg" />
              Richiesta accreditamento
            </Link>
          </ListGroup.Item>
        )}
        {controlla('Z14') && (
          <>
            {(controlla('Z3') || controlla('Z4') || controlla('Z5') || controlla('Z6') || controlla('Z7') || controlla('Z11')) && (
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-landmark" style={{ marginRight: '8px' }} size="lg" />
                    {' '}
                    Descrittori
                  </Accordion.Header>
                  <Accordion.Body className="p-0">
                    <ListGroup>
                      {controlla('Z3') && (
                        <ListGroup.Item
                          onClick={() => removeItemFromStorage()}
                          active={pathname === '/area-riservata/area-contrattuale'}
                        >
                          <Link to="/area-riservata/area-contrattuale">
                            {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-landmark" style={{ marginRight: '8px' }} size="lg" /> */}
                            {' '}
                            Aree Contrattuali CCNL
                          </Link>
                        </ListGroup.Item>
                      )}
                      {controlla('Z4')
                        && (JSON.parse(getItem('compartoSelected'))?.sequ_k_comparto === 1 || JSON.parse(getItem('compartoSelected'))?.sequ_k_comparto === 2)
                        && (
                          <ListGroup.Item
                            onClick={() => removeItemFromStorage()}
                            active={pathname === '/area-riservata/dimensioni-professionali'}
                          >
                            <Link to="/area-riservata/dimensioni-professionali">
                              {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-city" style={{ marginRight: '8px' }} size="lg" /> */}
                              {' '}
                              Dimensioni Professionali
                            </Link>
                          </ListGroup.Item>
                        )}
                      {controlla('Z5')
                        && (
                          <ListGroup.Item
                            onClick={() => removeItemFromStorage()}
                            active={pathname === '/area-riservata/famiglie-professionali'}
                          >
                            <Link to="/area-riservata/famiglie-professionali">
                              {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-user-tie" style={{ marginRight: '8px' }} size="lg" /> */}
                              {' '}
                              Famiglie Professionali
                            </Link>
                          </ListGroup.Item>
                        )}
                      {controlla('Z7') && (
                        <ListGroup.Item
                          onClick={() => removeItemFromStorage()}
                          active={pathname === '/area-riservata/ambiti-ruolo'}
                        >
                          <Link to="/area-riservata/ambiti-ruolo">
                            {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-circle-nodes" style={{ marginRight: '8px' }} size="lg" /> */}
                            {' '}
                            Ambiti di Ruolo
                          </Link>
                        </ListGroup.Item>
                      )}
                    </ListGroup>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-handshake" style={{ marginRight: '8px' }} size="lg" />
                  {' '}
                  Library delle Competenze
                </Accordion.Header>
                <Accordion.Body className="p-0">
                  <ListGroup>
                    {controlla('Z8') && (
                      <ListGroup.Item
                        onClick={() => removeItemFromStorage()}
                        active={pathname === '/area-riservata/competenze/CTP'}
                      >
                        <Link to="/area-riservata/competenze/CTP">
                          {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-handshake" style={{ marginRight: '8px' }} size="lg" /> */}
                          {' '}
                          Competenze Tecnico Professionali
                        </Link>
                      </ListGroup.Item>
                    )}
                    {controlla('Z9') && (
                      <ListGroup.Item
                        onClick={() => removeItemFromStorage()}
                        active={pathname === '/area-riservata/competenze/CC'}
                      >
                        <Link to="/area-riservata/competenze/CC">
                          {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-handshake" style={{ marginRight: '8px' }} size="lg" /> */}
                          {' '}
                          Competenze Comportamentali
                        </Link>
                      </ListGroup.Item>
                    )}
                    {controlla('Z10') && (
                      <ListGroup.Item
                        onClick={() => removeItemFromStorage()}
                        active={pathname === '/area-riservata/competenze/CTS'}
                      >
                        <Link to="/area-riservata/competenze/CTS">
                          {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-handshake" style={{ marginRight: '8px' }} size="lg" /> */}
                          {' '}
                          Competenze Tecnico Specialistiche
                        </Link>
                      </ListGroup.Item>
                    )}
                    {(controlla('Z47') && visualizzaCTC) && (
                      <ListGroup.Item
                        onClick={() => removeItemFromStorage()}
                        active={pathname === '/area-riservata/competenze/CTC'}
                      >
                        <Link to="/area-riservata/competenze/CTC">
                          {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-handshake" style={{ marginRight: '4px' }} size="lg" /> */}
                          {' '}
                          Competenze Tecniche Comuni
                        </Link>
                      </ListGroup.Item>
                    )}
                    {controlla('Z6') && (
                    <ListGroup.Item
                      onClick={() => removeItemFromStorage()}
                      active={pathname === '/area-riservata/aree-competenze'}
                    >
                      <Link to="/area-riservata/aree-competenze">
                        {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-file-contract" style={{ marginRight: '4px' }} size="lg" /> */}
                        {' '}
                        Aree delle Competenze
                      </Link>
                    </ListGroup.Item>
                    )}
                    {controlla('Z11') && (
                    <ListGroup.Item
                      onClick={() => removeItemFromStorage()}
                      active={pathname === '/area-riservata/grading'}
                    >
                      <Link to="/area-riservata/grading">
                        {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-person-dots-from-line" style={{ marginRight: '4px' }} size="lg" /> */}
                        {' '}
                        Grading
                      </Link>
                    </ListGroup.Item>
                    )}
                    {controlla('Z36') && (
                      <ListGroup.Item
                        onClick={() => removeItemFromStorage()}
                        active={pathname === '/area-riservata/matrice-corrispondenza-competenze'}
                      >
                        <Link to="/area-riservata/matrice-corrispondenza-competenze">
                          {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-hand-holding-hand" style={{ marginRight: '8px' }} size="lg" /> */}
                          {' '}
                          Matrice di Corrispondenza Competenze
                        </Link>
                      </ListGroup.Item>
                    )}
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-chalkboard-user" style={{ marginRight: '8px' }} size="lg" />
                  {' '}
                  Library dei Profili Professionali
                </Accordion.Header>
                <Accordion.Body className="p-0">
                  <ListGroup>
                    {(controlla('Z12')) && (
                      <ListGroup.Item
                        onClick={() => removeItemFromStorage()}
                        active={pathname === '/area-riservata/profili-professionali'}
                      >
                        <Link to="/area-riservata/profili-professionali">
                          {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-chalkboard-user" style={{ marginRight: '8px' }} size="lg" /> */}
                          {' '}
                          Profili Professionali
                        </Link>
                      </ListGroup.Item>
                    )}
                    {controlla('Z13') && (
                      <ListGroup.Item
                        onClick={() => removeItemFromStorage()}
                        active={pathname === '/area-riservata/profili-ruolo'}
                      >
                        <Link to="/area-riservata/profili-ruolo">
                          {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-id-card-clip" style={{ marginRight: '8px' }} size="lg" /> */}
                          {' '}
                          Profili di Ruolo
                        </Link>
                      </ListGroup.Item>
                    )}
                    {/* {controlla('Z31') && ( */}
                    {controlla('Z36') && (
                      <ListGroup.Item
                        onClick={() => removeItemFromStorage()}
                        active={pathname === '/area-riservata/matrice-corrispondenza-profili'}
                      >
                        <Link to="/area-riservata/matrice-corrispondenza-profili">
                          {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-users-gear" style={{ marginRight: '8px' }} size="lg" /> */}
                          Matrice di Corrispondenza Profili di Ruolo
                        </Link>
                      </ListGroup.Item>
                    )}
                    {/* )} */}
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </>
        )}
        {(controlla('Z32') || controlla('Z33') || controlla('Z35')) && (
          <Accordion>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-clipboard-user" style={{ marginRight: '8px' }} size="lg" />
                {' '}
                {idIdentita === 6 ? 'Profilo Dipendente' : 'Profili Dipendenti'}
              </Accordion.Header>
              <Accordion.Body className="p-0">
                <ListGroup>
                  {controlla('Z32') && (
                    <ListGroup.Item
                      onClick={() => removeItemFromStorage()}
                      active={pathname === '/area-riservata/scheda-competenze'}
                    >
                      <Link to="/area-riservata/scheda-competenze">
                        {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-clipboard-user" style={{ marginRight: '8px' }} size="lg" /> */}
                        {' '}
                        Scheda Competenze
                      </Link>
                    </ListGroup.Item>
                  )}
                  {controlla('Z35') && (
                    <ListGroup.Item
                      onClick={() => removeItemFromStorage()}
                      active={pathname === '/area-riservata/assegnazione-profilo'}
                    >
                      <Link to="/area-riservata/assegnazione-profilo">
                        {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-id-badge" style={{ marginRight: '8px' }} size="lg" /> */}
                        {' '}
                        Assegnazione Profilo
                      </Link>
                    </ListGroup.Item>
                  )}
                  {controlla('Z33') && (
                    <ListGroup.Item
                      onClick={() => removeItemFromStorage()}
                      active={pathname === '/area-riservata/lista-utenti-schede'}
                    >
                      <Link to="/area-riservata/lista-utenti-schede">
                        {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-users-rectangle" style={{ marginRight: '8px' }} size="lg" /> */}
                        {' '}
                        Schede Competenze
                      </Link>
                    </ListGroup.Item>
                  )}
                  {controlla('Z38') && (
                    <ListGroup.Item
                      onClick={() => removeItemFromStorage()}
                      active={pathname === '/area-riservata/assessment/best-fit'}
                    >
                      <Link to="/area-riservata/assessment/best-fit">
                        {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-puzzle-piece" style={{ marginRight: '4px' }} size="lg" /> */}
                        {' '}
                        Best Fit
                      </Link>
                    </ListGroup.Item>
                  )}
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        )}
        {(controlla('Z18') || controlla('Z15') || controlla('Z16') || controlla('Z17') || controlla('Z48')) && (
          <Accordion>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-arrows-spin" style={{ marginRight: '8px' }} size="lg" />
                {' '}
                Assessment
              </Accordion.Header>
              <Accordion.Body className="p-0">
                <ListGroup>
                  {controlla('Z15') && (
                  <ListGroup.Item
                    onClick={() => removeItemFromStorage()}
                    active={pathname === '/area-riservata/assessment'}
                  >
                    <Link to="/area-riservata/assessment">
                      {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-arrows-spin" style={{ marginRight: '8px' }} size="lg" /> */}
                      {' '}
                      Cicli di Assessment
                    </Link>
                  </ListGroup.Item>
                  )}
                  {controlla('Z17') && (
                    <ListGroup.Item
                      onClick={() => removeItemFromStorage()}
                      active={pathname === '/area-riservata/etero-assessment'}
                    >
                      <Link to="/area-riservata/etero-assessment">
                        {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-person-arrow-down-to-line" style={{ marginRight: '8px' }} size="lg" /> */}
                        {' '}
                        Etero Valutazione
                      </Link>
                    </ListGroup.Item>
                  )}
                  {controlla('Z15') && (
                  <ListGroup.Item
                    onClick={() => removeItemFromStorage()}
                    active={pathname === '/area-riservata/analisi-assessment'}
                  >
                    <Link to="/area-riservata/analisi-assessment">
                      {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-file-contract" style={{ marginRight: '8px' }} size="lg" /> */}
                      {' '}
                      Analisi Esiti
                    </Link>
                  </ListGroup.Item>
                  )}
                  {controlla('Z16') && (
                    <ListGroup.Item
                      onClick={() => removeItemFromStorage()}
                      active={pathname === '/area-riservata/auto-assessment'}
                    >
                      <Link to="/area-riservata/auto-assessment">
                        {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-person-arrow-up-from-line" style={{ marginRight: '8px' }} size="lg" /> */}
                        {' '}
                        Auto Valutazione
                      </Link>
                    </ListGroup.Item>
                  )}
                  {controlla('Z48') && (
                    <ListGroup.Item
                      onClick={() => removeItemFromStorage()}
                      active={pathname === '/area-riservata/quadro-competenze-tecniche-comuni'}
                    >
                      <Link to="/area-riservata/quadro-competenze-tecniche-comuni">
                        Quadro Competenze Tecniche Comuni
                      </Link>
                    </ListGroup.Item>
                  )}
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        )}
        {(controlla('Z31') || controlla('Z37')) && (
          <Accordion>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-people-group" style={{ marginRight: '8px' }} size="lg" />
                {' '}
                Programmazione del Fabbisogno
              </Accordion.Header>
              <Accordion.Body className="p-0">
                <ListGroup>
                  {/* {controlla('Z31') && (
                <ListGroup.Item onClick={() => removeItemFromStorage()}>
                  <Link to="/area-riservata/demo-bpm">
                    <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-file-circle-plus" style={{ marginRight: '8px' }} size="lg" />
                    {' '}
                    {idIdentita === 10 ? 'Richieste di Fabbisogno Vecchio' : 'Piani di Fabbisogno Vecchio'}
                  </Link>
                </ListGroup.Item>
                )} */}
                  {controlla('Z31') && (
                    <ListGroup.Item
                      onClick={() => removeItemFromStorage()}
                      active={pathname === '/area-riservata/bpm'}
                    >
                      <Link to="/area-riservata/bpm">
                        {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-file-circle-plus" style={{ marginRight: '8px' }} size="lg" /> */}
                        {' '}
                        {idIdentita === 10 ? 'Richieste di Fabbisogno' : 'Analisi dei fabbisogni professionali'}
                      </Link>
                    </ListGroup.Item>
                  )}
                  {controlla('Z37') && (
                    <ListGroup.Item
                      onClick={() => removeItemFromStorage()}
                      active={pathname === '/area-riservata/ptfa'}
                    >
                      <Link to="/area-riservata/ptfa">
                        {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-people-group" style={{ marginRight: '8px' }} size="lg" /> */}
                        {' '}
                        PTFA
                      </Link>
                    </ListGroup.Item>
                  )}
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        )}
        {(controlla('Z40') || controlla('Z39')) && (
          <Accordion>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-puzzle-piece" style={{ marginRight: '8px' }} size="lg" />
                {' '}
                Reclutamento
              </Accordion.Header>
              <Accordion.Body className="p-0">
                <ListGroup>
                  {controlla('Z39') && (
                    <ListGroup.Item
                      onClick={() => removeItemFromStorage()}
                      active={pathname === '/area-riservata/bandi'}
                    >
                      <Link to="/area-riservata/bandi">
                        {/* <FontAwesomeIcon aria-hidden="true" icon="file-alt" size="lg" /> */}
                        {' '}
                        Schema Bando-Avviso
                      </Link>
                    </ListGroup.Item>
                  )}
                  {(controlla('Z40') && idAmministrazione === 'formezpa') && (
                    <ListGroup.Item
                      onClick={() => removeItemFromStorage()}
                      active={pathname === `${gestioneCVUrl}`}
                    >
                      <a href={`${gestioneCVUrl}`} target="_blank" rel="noreferrer">
                        {/* <FontAwesomeIcon aria-hidden="true" icon="user" size="lg" /> */}
                        {' '}
                        Gestione CV
                      </a>
                    </ListGroup.Item>
                  )}
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        )}
        {(controlla('Z42') || controlla('Z43') || controlla('Z44') || controlla('Z45') || controlla('Z46')) && (
        <Accordion className="border-end">
          <Accordion.Item eventKey="1" className="border-end">
            <Accordion.Header>
              <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-book" style={{ marginRight: '4px' }} size="lg" />
              {' '}
              Sviluppo Professionale
            </Accordion.Header>
            <Accordion.Body className="p-0">
              <ListGroup>
                {controlla('Z42') && (
                  <ListGroup.Item
                    onClick={() => removeItemFromStorage()}
                    active={pathname === '/area-riservata/formazione/catalogo-opportunita-formative'}
                  >
                    <Link to="/area-riservata/formazione/catalogo-opportunita-formative">
                      {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-book" style={{ marginRight: '4px' }} size="lg" /> */}
                      {' '}
                      Catalogo delle Opportunità Formative
                    </Link>
                  </ListGroup.Item>
                )}
                {controlla('Z43') && (
                  <ListGroup.Item
                    onClick={() => removeItemFromStorage()}
                    active={pathname === '/area-riservata/formazione/piano-fabbisogni-formativi'}
                  >
                    <Link to="/area-riservata/formazione/piano-fabbisogni-formativi">
                      {/* <FontAwesomeIcon aria-hidden="true" icon="clipboard-list" size="lg" /> */}
                      {' '}
                      Piani dei Fabbisogni Formativi
                    </Link>
                  </ListGroup.Item>
                )}
                {controlla('Z44') && (
                  <ListGroup.Item
                    onClick={() => removeItemFromStorage()}
                    active={pathname === '/area-riservata/formazione/piano-formativo-collettivo'}
                  >
                    <Link to="/area-riservata/formazione/piano-formativo-collettivo">
                      {/* <FontAwesomeIcon aria-hidden="true" icon="users" size="lg" /> */}
                      {' '}
                      Piani Formativi Collettivi
                    </Link>
                  </ListGroup.Item>
                )}
                {controlla('Z45') && (
                  <ListGroup.Item
                    onClick={() => removeItemFromStorage()}
                    active={pathname === '/area-riservata/formazione/piano-formativo-individuale'}
                  >
                    <Link to="/area-riservata/formazione/piano-formativo-individuale">
                      {/* <FontAwesomeIcon aria-hidden="true" icon="user" size="lg" /> */}
                      {' '}
                      Piani Formativi Individuali
                    </Link>
                  </ListGroup.Item>
                )}
                {(controlla('Z46')) && (
                  <ListGroup.Item
                    onClick={() => removeItemFromStorage()}
                    active={pathname === '/area-riservata/formazione/scheda-corsi'}
                  >
                    <Link to="/area-riservata/formazione/scheda-corsi">
                      {/* {idIdentita === 6
                        ? <FontAwesomeIcon aria-hidden="true" icon="book-open" style={{ marginRight: '4px' }} size="lg" />
                        : <FontAwesomeIcon aria-hidden="true" icon="user-graduate" style={{ marginRight: '4px' }} size="lg" />} */}
                      {' '}
                      Scheda Corsi
                    </Link>
                  </ListGroup.Item>
                )}
              </ListGroup>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        )}
        {controlla('Z41') && (
        <Accordion className="border-end">
          <Accordion.Item eventKey="1" className="border-end">
            <Accordion.Header>
              <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-group-arrows-rotate" style={{ marginRight: '4px' }} size="lg" />
              {' '}
              Rewarding
            </Accordion.Header>
            <Accordion.Body className="p-0">
              <ListGroup>
                {/* {controlla('Z15') && ( */}
                <ListGroup.Item
                  onClick={() => removeItemFromStorage()}
                  active={pathname === '/area-riservata/rewarding'}
                >
                  <Link to="/area-riservata/rewarding">
                    {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-group-arrows-rotate" style={{ marginRight: '4px' }} size="lg" /> */}
                    {' '}
                    Cicli di Valutazione
                  </Link>
                </ListGroup.Item>
                {/* )} */}
              </ListGroup>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        )}
        {controlla('Z28') && (
          <Accordion>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <FontAwesomeIcon aria-hidden="true" icon="chart-column" size="lg" style={{ marginRight: '8px' }} />
                {' '}
                Reporting
              </Accordion.Header>
              <Accordion.Body className="p-0">
                <ListGroup>
                  <ListGroup.Item active={pathname === '/area-riservata/statistiche-sistema-professionale'}>
                    <Link to="/area-riservata/statistiche-sistema-professionale">
                      {/* <FontAwesomeIcon aria-hidden="true" icon="chart-column" size="lg" /> */}
                      {' '}
                      Sistema Professionale
                    </Link>
                  </ListGroup.Item>
                  <ListGroup.Item active={pathname === '/area-riservata/statistiche-matrice-profili-professionali'}>
                    <Link to="/area-riservata/statistiche-matrice-profili-professionali">
                      {/* <FontAwesomeIcon aria-hidden="true" icon="table" size="lg" /> */}
                      {' '}
                      Sintesi dei Profili Professionali e di Ruolo
                    </Link>
                  </ListGroup.Item>
                  <ListGroup.Item active={pathname === '/area-riservata/statistiche-assessment'}>
                    <Link to="/area-riservata/statistiche-assessment">
                      {/* <FontAwesomeIcon aria-hidden="true" icon="chart-simple" size="lg" /> */}
                      {' '}
                      Assessment Gap Analysis
                    </Link>
                  </ListGroup.Item>
                  <ListGroup.Item active={pathname === '/area-riservata/statistiche-sviluppo-professionale-rewarding'}>
                    <Link to="/area-riservata/statistiche-sviluppo-professionale-rewarding">
                      {/* <FontAwesomeIcon aria-hidden="true" icon="chart-simple" size="lg" /> */}
                      {' '}
                      Processi HR
                    </Link>
                  </ListGroup.Item>
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        )}
        {(controlla('Z19')
          || controlla('Z22')
          || controlla('Z24')
          || controlla('Z20')
          || controlla('Z23')
          || controlla('Z25')
          || controlla('Z26')
          || controlla('Z27')
          || (idIdentita !== 1 && idIdentita !== 6)
        ) && (
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <FontAwesomeIcon aria-hidden="true" icon="box-archive" size="lg" style={{ marginRight: '8px' }} />
              {'  '}
              Utility
            </Accordion.Header>
            <Accordion.Body className="p-0">
              <ListGroup>
                {controlla('Z19') && (
                <ListGroup.Item
                  onClick={() => removeItemFromStorage()}
                  active={pathname === '/area-riservata/gestione-news'}
                >
                  <Link to="/area-riservata/gestione-news">
                    {/* <FontAwesomeIcon aria-hidden="true" icon="file-shield" size="lg" /> */}
                    {' '}
                    Gestione news
                  </Link>
                </ListGroup.Item>
                )}
                {controlla('Z22') && (
                <ListGroup.Item
                  onClick={() => removeItemFromStorage()}
                  active={pathname === '/area-riservata/gestione-news-esterne'}
                >
                  <Link to="/area-riservata/gestione-news-esterne">
                    {/* <FontAwesomeIcon aria-hidden="true" icon="newspaper" size="lg" /> */}
                    {' '}
                    Gestione news esterne
                  </Link>
                </ListGroup.Item>
                )}
                {controlla('Z24') && (
                <ListGroup.Item
                  onClick={() => removeItemFromStorage()}
                  active={pathname === '/area-riservata/news'}
                >
                  <Link to="/area-riservata/news">
                    {/* <FontAwesomeIcon aria-hidden="true" icon="box-archive" size="lg" /> */}
                    {' '}
                    News
                  </Link>
                </ListGroup.Item>
                )}
                {controlla('Z20') && (
                <ListGroup.Item
                  onClick={() => removeItemFromStorage()}
                  active={pathname === '/area-riservata/gestione-faq'}
                >
                  <Link to="/area-riservata/gestione-faq">
                    {/* <FontAwesomeIcon aria-hidden="true" icon="person-circle-question" size="lg" /> */}
                    {' '}
                    Gestione FAQ
                  </Link>
                </ListGroup.Item>
                )}
                {controlla('Z23') && (
                <ListGroup.Item
                  onClick={() => removeItemFromStorage()}
                  active={pathname === '/area-riservata/gestione-faq-esterne'}
                >
                  <Link to="/area-riservata/gestione-faq-esterne">
                    {/* <FontAwesomeIcon aria-hidden="true" icon="question-circle" size="lg" /> */}
                    {' '}
                    Gestione FAQ esterne
                  </Link>
                </ListGroup.Item>
                )}
                {controlla('Z25') && (
                <ListGroup.Item
                  onClick={() => removeItemFromStorage()}
                  active={pathname === '/area-riservata/faq'}
                >
                  <Link to="/area-riservata/faq">
                    {/* <FontAwesomeIcon aria-hidden="true" icon="clipboard-question" size="lg" /> */}
                    {' '}
                    FAQ
                  </Link>
                </ListGroup.Item>
                )}
                {controlla('Z26') && (
                <ListGroup.Item
                  onClick={() => removeItemFromStorage()}
                  active={pathname === '/area-riservata/template'}
                >
                  <Link to="/area-riservata/template">
                    {/* <FontAwesomeIcon aria-hidden="true" icon="file-invoice" size="lg" /> */}
                    {' '}
                    Gestione questionari
                  </Link>
                </ListGroup.Item>
                )}
                {controlla('Z27') && (
                <ListGroup.Item
                  onClick={() => removeItemFromStorage()}
                  active={pathname === '/area-riservata/questionari'}
                >
                  <Link to="/area-riservata/questionari">
                    {/* <FontAwesomeIcon aria-hidden="true" icon="file-signature" size="lg" /> */}
                    {' '}
                    Questionari
                  </Link>
                </ListGroup.Item>
                )}
                {controlla('Z34') && (
                <ListGroup.Item
                  onClick={() => removeItemFromStorage()}
                  active={pathname === '/area-riservata/forum'}
                >
                  <Link to="/area-riservata/forum">
                    {/* <FontAwesomeIcon aria-hidden="true" icon="comments" size="lg" /> */}
                    {' '}
                    Forum
                  </Link>
                </ListGroup.Item>
                )}
                {manualiUtente[idIdentita] && (
                <ListGroup.Item
                  onClick={() => removeItemFromStorage()}
                >
                  <a href={`${urlContenutiPubblici}/${manualiUtente[idIdentita]}`} target="_blank" rel="noreferrer">
                    {/* <FontAwesomeIcon aria-hidden="true" icon="book" size="lg" /> */}
                    {' '}
                    Manuale Utente
                  </a>
                </ListGroup.Item>
                )}
                {client && controlla('Z21') && (
                <ListGroup.Item
                  onClick={() => removeItemFromStorage()}
                  active={pathname === '/area-riservata/chat'}
                >
                  <Link to="/area-riservata/chat">
                    {/* <FontAwesomeIcon aria-hidden="true" icon="comment" style={{ marginRight: '8px' }} size="lg" /> */}
                    {' '}
                    Chat
                    {' '}
                    {notification && !history.location.pathname.includes('chat')
                      ? <Badge bg="grey">{notification}</Badge>
                      : null}
                  </Link>
                </ListGroup.Item>
                )}
                {idIdentita !== 1 && idIdentita !== 11 && idIdentita !== 12 && (
                <ListGroup.Item
                  onClick={() => removeItemFromStorage()}
                  active={pathname === '/area-riservata/tutorial'}
                >
                  <Link to="/area-riservata/tutorial">
                    {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-book-open" size="lg" /> */}
                    {' '}
                    Tutorial
                  </Link>
                </ListGroup.Item>
                )}
              </ListGroup>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        )}
        {(controlla('Z29') || controlla('Z30')) && (
          <Accordion>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-arrows-spin" size="lg" style={{ marginRight: '8px' }} />
                {' '}
                Demo Assessment
              </Accordion.Header>
              <Accordion.Body className="p-0">
                <ListGroup>
                  {controlla('Z29') && (
                    <ListGroup.Item active={pathname === '/area-riservata/demo-assessment/ciclo-assessment'}>
                      <Link to="/area-riservata/demo-assessment/ciclo-assessment">
                        {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-arrows-spin" size="lg" /> */}
                        {' '}
                        Cicli Assessment
                      </Link>
                    </ListGroup.Item>
                  )}
                  {controlla('Z30') && (
                    <ListGroup.Item active={pathname === '/area-riservata/demo-assessment/elenco-assessment'}>
                      <Link to="/area-riservata/demo-assessment/elenco-assessment">
                        {/* <FontAwesomeIcon aria-hidden="true" icon="fa-solid fa-person-arrow-down-to-line" style={{ marginRight: '8px' }} size="lg" /> */}
                        {' '}
                        Assessment
                      </Link>
                    </ListGroup.Item>
                  )}
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        )}
      </ListGroup>
    </nav>
  );
}

export default Sidebar;
